import logoVariants from '@/assets/img/logo';
import iconsPng from '@/assets/img/png/icons';
import ArrowIconDown from '@/components/atoms/ArrowIconDown';
import ArrowIconUp from '@/components/atoms/ArrowIconUp';
import CircleFillOutWithText from '@/components/molecules/WellnessStateCircle/CircleFillOutWithText';
import { MAX_GOALS_PER_DOMAIN } from '@/constants/defaultValues';
import { background, text } from '@/theme/colors/palettes';
import { EGrowthDomainGoalTrend, TDomainGrowthZone } from '@/types/GrowthZone.types';
import { THealthDomain } from '@/types/Health.types';
import { capitalize } from '@/utils/stringUtils';
import { Box, HStack, Image, Text, VStack } from '@chakra-ui/react';
import React from 'react';

interface Props {
  domainGoalData: TDomainGrowthZone;
}

const DomainGoalsHeader = ({ domainGoalData }: Props) => {
  const isOverallDomain = domainGoalData.domain === 'overall';

  return (
    <HStack width={'100%'} alignItems={'center'} justify={'space-between'}>
      <HStack gap={3} alignItems={'center'}>
        <Box backgroundColor={background.lightBlue} padding={'6px'} rounded={'7px'} height={'40px'} width={'40px'}>
          <Image
            src={
              isOverallDomain
                ? domainGoalData.goals.length > 0
                  ? logoVariants.purpleNoText160x160
                  : logoVariants.grayNoText88x88
                : domainGoalData.goals.length > 0
                  ? iconsPng.wellnessDomainsPurple[domainGoalData.domain as THealthDomain]
                  : iconsPng.wellnessDomainsGray[domainGoalData.domain as THealthDomain]
            }
            alt="logo-or-domain"
          />
        </Box>
        <VStack alignItems={'start'} gap={1}>
          <Text variant="urbanistBold" color={text.mediumBlue}>
            {capitalize(domainGoalData.domain)}
          </Text>
          <VStack>
            <Text variant="urbanistMaximumBold" color={text.mediumGray} fontSize={12} lineHeight={'12px'}>
              {domainGoalData.goals.length} / {MAX_GOALS_PER_DOMAIN} GOALS
            </Text>
          </VStack>
        </VStack>
      </HStack>

      <HStack alignItems={'center'} gap={2.5}>
        <VStack gap={1.5} alignItems={'end'}>
          <Text variant={'urbanistMaximumBold'} color={text.mediumBlue} lineHeight={'12px'}>
            {domainGoalData.score.toFixed()}
          </Text>
          <Text variant={'urbanistSemiBold'} color={text.mediumGray} fontSize={12} lineHeight={'10px'}>
            / 100
          </Text>
        </VStack>
        <HStack alignItems={'center'} gap={2}>
          <CircleFillOutWithText
            hasBackgroundCircleFillOut
            svgId={`${domainGoalData.domain}-svg-id`}
            percentageFilled={domainGoalData.score}
            showPercentageText={false}
            circleDiameter={20}
            boxShadow="none"
            thickness={3}
          />
          <VStack gap={0} alignItems={'end'}>
            <Text variant="urbanistMaximumBold" color={text.mediumBlue} lineHeight={'12px'}>
              Trend
            </Text>
            <Text variant="urbanistSemiBold" color={text.mediumGray} fontSize={12}>
              Last 30 days
            </Text>
          </VStack>
        </HStack>
        {domainGoalData.trend === EGrowthDomainGoalTrend.IMPROVING ? <ArrowIconUp /> : <ArrowIconDown />}
      </HStack>
    </HStack>
  );
};

export default DomainGoalsHeader;
